import React, { Component } from "react";
import * as actions from '../../../stores/actionsList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import HttpServices from "../../../utils/Http.services";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from "../../../utils/functions";
import { checkTranslation, translate } from "../../../utils/useful";
import Board from "../../../components/dragable/Board";
// import Responsive from "../../../components/Responsive";
import ButtonAnimated from "../../../components/buttons/ButtonAnimated";
// import CollectionView from "./CollectionView";
// import StagesManager from "../../../components/StagesManager";
// import SwitchInput from "../../../components/inputs/SwitchInput";
import FormViewer from "../../../components/FormViewer";
import FixedView from "../../../components/FixedView";
import SidebarView from "../../../components/SidebarView";
import { MenuBuilderItems, MenuBuilderObjects } from "../../../variables/menuBuilderData";
// import { nanoid } from "nanoid";
import { v4 as uuidv4 } from "uuid";

class NavigationsView extends Component {

    state = {
        data: [],
        showData: [],
        navigation: {},

        // itemsList: [
        //     { id: 'dropdown', name: 'Drop down', icon: '/assets/icons/useful/down-arrow (2).png' },
        //     { id: 'page', name: 'Yonnect Page', icon: '/assets/icons/useful/website.png' },
        //     { id: 'link', name: 'Link', icon: '/assets/icons/useful/link (2).png' },
        //     { id: 'action', name: 'Action', icon: '/assets/icons/useful/thunder.png' },

        // ],


        // columns: [
        //     { id: 'column-1', title: 'Column 1' },
        //     { id: 'column-2', title: 'Column 2' },
        // ],

        // tasks: [
        //     { id: 'task-1', content: 'Task 1', column: 'column-1', row: 0, dropIndex: 0 },
        //     { id: 'task-2', content: 'Task 2', column: 'column-1', row: 0, dropIndex: 1 },
        //     { id: 'task-3', content: 'Task 3', column: 'column-1', row: 1, dropIndex: 0 },
        //     { id: 'task-4', content: 'Task 4', column: 'column-1', row: 1, dropIndex: 1 },
        // ],
        checkedAll: false,
        menuHeight: 36,
        buttonHeight: 52,
        headers: [
            { key: 'active', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Activate navigation menu for this page', default: false, required: false } },
            {
                key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}Navigation type', type: 'local', items: [{ value: 'template', title: '{{lang}}Select a template' }, { value: 'basic', title: '{{lang}}Create basic menu' }], isSearchable: true, placeholder: '{{lang}}Select ...', required: false },
                dependencies: [{
                    refKey: 'active', targetKey: 'type',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.active' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,

                }],
            },
            {
                key: 'template', type: 'SelectInput', information: { label: '{{lang}}Template', updateAfterSelect: true, isSearchable: true, address: 'getAllCountries', filter: { appletId: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false },
                dependencies: [{
                    refKey: ['active', 'type'], targetKey: 'template',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.active' }, operator: { value: '==' }, target: { value: true } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'template' } } } },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,

                }],
            },

        ],
        name: null,
    }

    componentDidMount() {
        // console.log('this,oriosdas', this.props)
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                // title: '{{lang}}New Inquery',
                headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.cancel()

            })

            setTimeout(() => {
                this.setState({ revealFixed: true }, () => {
                    this.props.setHeader("dummy", 1)
                })
            }, 50);
        }
        if (this.props.initData) {
            this.setState({ navigation: this.props.initData })
        }
        // this.fetchData()
    }

    headerIdentityComponent = () => {
        return (
            <div className='white d-flex flex-column' >
                <p className="text-semibold text-small">{translate("Navigation editor")}</p>
                <p className="text-semibold text-smallest">{translate(this.props.name)}</p>
                {/* <input onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert name ...')} /> */}
            </div>
        )
    }

    setName = (value) => {
        console.log('setName', value)
        this.setState({ name: value }, () => {
        })
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.submitMenu}
                    title={'{{lang}}Save'}
                    icon='/assets/icons/arrow-right-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    submitMenu = () => {
        let data = this.state.navigation
        if (data) {
            this.props.submitMenu(data)
        }
    }

    // saveNavigation = () => {
    //     let showData = this.state.showData
    //     let page = this.props.page
    //     // let isEditing = data._id ? true : false
    //     let address = false ? (page.editUrl ?? page.addUrl) : page.addUrl
    //     let data = { page: showData }
    //     if (page.postBody) {
    //         data = { ...data, ...page.postBody }
    //     }
    //     for (const [key, value] of Object.entries(data)) {
    //         if (/\{\{(.*?)\}\}/.test(value)) {
    //             if (this.props.variables) {
    //                 data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //             }
    //         }
    //     }
    //     HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isPostingData: false })

    //         if (fetchError) {
    //         }
    //     })
    // }

    // fetchData = (getCount, filter) => {
    //     this.setState({ isLoadingData: true })
    //     let body = { applet: '{{appletId}}', appletHub: '{{appletHub}}', type: 'page' }//this.props.page.filter ? { ...this.props.page.filter } : {}
    //     // let page = this.props.page
    //     // console.log('this.props.page', this.props.page)
    //     // body.limit = this.state.limit
    //     // body.skip = this.state.currentPage
    //     // body.page = page.key
    //     for (const [key, value] of Object.entries(body)) {
    //         if (/\{\{(.*?)\}\}/.test(value)) {
    //             if (this.props.variables) {
    //                 body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //             }
    //         }
    //     }
    //     // if (this.state.totalCount == null || getCount) {
    //     //     body.getCount = true
    //     // }
    //     // body.frame = this.props.page?._id
    //     // body.filter = filter
    //     // console.log('bodyyyyyyy', body)
    //     HttpServices.request('getFrames', body, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })
    //         if (fetchError) {
    //             // console.log('ERRERRER', this.props.page)
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
    //             return
    //         }
    //         // console.log('fetchResult, fetchError', fetchResult, fetchError)
    //         this.setState({ showTable: false }, () => {
    //             this.setState({ data: fetchResult.info, showTable: true }, () => {
    //                 let data = this.state.data
    //                 data.forEach(el => {
    //                     el.showMain = false
    //                     el.parent = null
    //                 });
    //                 this.setState({ data })
    //                 // this.setCharacters(fetchResult.info)
    //             })
    //         })
    //         if (fetchResult.count != null) {
    //             this.setState({ totalCount: fetchResult.count })
    //         }
    //     })
    // }

    // setCharacters = (data) => {
    //     let fields = []
    //     data?.map((element) => {
    //         fields.push({
    //             id: element._id??element.id,
    //             name: element.name,
    //             showMain: (element.showMain == undefined || element.showMain == true) ? true : false,
    //         })
    //     })
    //     this.setState({ characters: fields });
    // }

    onDragEnd = (result) => {
        let items = Array.from(this.state.showData);
        let dragItems = JSON.parse(JSON.stringify(items))
        let [reorderItem] = items.splice(result.source.index, 1);
        // console.log('resaaaaaaaaaaaaaaa', reorderItem)
        // console.log('resaaaaaaaaaaaaaaa', items)
        // console.log('resaaaaaaaaaaaaaaa', items.splice(result.source.index - 1, 1)[0]._id)
        // let parents = reorderItem.parent
        // parents.push(dragItems.splice(result.source.index, 1)[0]._id)
        reorderItem.parent = dragItems.splice(result.source.index, 1)[0]._id
        // console.log('resaaaaaaaaaaaaaaa', reorderItem)
        // console.log('resaaaaaaaaaaaaaaa', items)
        items.splice(result.destination.index, 0, reorderItem);
        this.setState({ showData: items }, () => {
        });
    }

    searchInput = (e) => {
        this.setState({ search: e.target.value }, () => {
            this.filterHandler();
        });
    }

    // changeShow = (item, index) => {
    //     let { data, checkedAll } = this.state
    //     let check = true
    //     if (item == 'all') {
    //         if (checkedAll) {
    //             data.forEach(el => {
    //                 el.showMain = false
    //             });
    //         }
    //         else {
    //             data.forEach(el => {
    //                 if (el.showMain == undefined || el.showMain == false) {
    //                     el.showMain = true
    //                 }
    //             });
    //         }
    //         checkedAll = !checkedAll
    //     }
    //     else {
    //         if (data[index].showMain == undefined) {
    //             data[index].showMain = true
    //         }
    //         data[index].showMain = !data[index].showMain
    //         if (checkedAll) {
    //             data.forEach(el => {
    //                 if (el.showMain == false) {
    //                     checkedAll = false
    //                 }
    //             });
    //         }
    //         else {
    //             data.forEach(el => {
    //                 if (el.showMain == false) {
    //                     check = false
    //                 }
    //             });
    //             if (check) {
    //                 checkedAll = true
    //             }
    //         }
    //     }
    //     this.setState({ data, checkedAll })
    // }

    // changeShowAll = (items, index) => {
    //     let { data, checkedAll } = this.state

    // }

    setShowData = () => {
        let { data, showData } = this.state
        data.forEach(el => {
            if (el.showMain) {
                // if (el.parent) {
                //     el.row = 1
                // } else {
                //     el.row = 0

                // }
                // el.column = 'column-1'
                showData.push(el)
            }
        });
        this.setState({ showData })
    }
    setData = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) { cb() }
        })
    }

    changeStage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    changeActivation = (key, value) => {
        let navigation = this.state.navigation
        navigation[key] = value
        this.setState({ navigation })
    }


    liveChange = (data, init, key, value, extra, full) => {

        let navigation = this.state.navigation
        navigation[key] = value

        this.setState({ navigation })

        if (key == 'type') {
            this.setState({ revealFixed: false }, () => {
                this.setState({ revealFixed: true })
            })
        }
    }


    applyConfig = () => {

        let configData = this.configForm.getForm()
        let currentItem = this.state.currentItem
        let currentIndex = this.state.currentIndex
        // let currentType = this.state.currentType

        // console.log(configData)




        if (configData) {

            this.setState({ isLoadingApply: true })


            HttpServices.handleFiles(null, configData, () => {


                let navigation = this.state.navigation
                if (!navigation.list) {
                    navigation.list = []
                }


                if (currentIndex != null) {

                    navigation.list.forEach((item, index) => {
                        if (item._id == currentItem._id) {
                            currentIndex = index
                        }
                    })

                    navigation.list[currentIndex].information = configData
                } else {
                    currentItem.information = configData
                    navigation.list.push(currentItem)
                }

                // console.log(navigation)

                this.setState({ navigation }, () => {

                    this.setState({ isLoadingApply: false })

                    this.sidebarView.hideModal()
                    if (this.board) {
                        this.board.listUpdated()
                    }
                })

            })

        }


    }


    openAddItem = (item, index) => {
        let headers = MenuBuilderObjects[item.type]?.headers
        let currentItem = { _id: uuidv4(), type: item.type, information: {}, parents: [] }
        this.setState({ menuHeaders: headers, currentType: MenuBuilderObjects[item.id], currentItem, currentIndex: null })
        this.addNewFixedView.hideView()
        this.sidebarView.open()
    }

    updateList = (newList, cb) => {

        // console.log(newList)
        let navigation = this.state.navigation
        navigation.list = newList
        this.setState({ navigation }, () => {
            cb()
        })

    }



    openEdit = (item, index) => {
        let headers = MenuBuilderObjects[item.type]?.headers
        // console.log(item)
        this.setState({ menuHeaders: headers, currentType: MenuBuilderObjects[item.id], currentItem: item, currentIndex: index })
        this.sidebarView.open()

    }


    render() {

        return (
            <div className="h-100 sc-gray4" style={{ backgroundColor: '#f0f0f0', overflow: 'auto' }}>

                <div className=" mb-5 mt-2 w-100 p-2 flexc flex-column">
                    <div className="p-4 px-4 " style={{ width: '100%', maxWidth: 600, backgroundColor: '#fff', borderRadius: 20 }}>

                        <div>

                            <div className="mb-4">
                                <p className="text-small">{translate("You can configure the navigation menu for this page. You can use this option for creating custom menu and better nativation between the pages.")}</p>
                            </div>


                            <div className="">
                                <FormViewer initData={this.state.navigation} ref={el => this.form = el} liveChange={this.liveChange} headers={this.state?.headers} formClass="bordered-form" inputClass={'bordered-input'} nopadding={true} />
                            </div>

                            {/* <div className="flexc">
                                <SwitchInput data={this.state.navigation?.active} changeValue={this.changeActivation} header={{ key: 'active', information: {} }} />
                                <p className="mld-3 text-semibold text-normal">{translate("Activate navigation menu for this page")}</p>
                            </div> */}

                        </div>

                        {(this.state.navigation?.type == 'basic') && (
                            <>
                                {/* <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', sm: '12', md: '6', lg: '5', xl: '4' }}>
                                    <div className="w-100 h-100 px-2 py-3" style={{}}>
                                        <div className="w-100 h-100 br-8" style={{ border: '1px solid #ededed', position: 'relative' }}>
                                            <div className="w-100 px-3 py-2" style={{ borderBottom: '1px solid #ededed', height: this.state.menuHeight }}>
                                                <p className="font-size-14 weight-500 main-c2">{translate('Pages')}</p>
                                            </div>
                                            <div className="w-100" style={{}}>
                                                <div className="flexc scroll-no-scrollbar px-3 py-2" style={{ height: `calc(100% - ${this.state.menuHeight + this.state.buttonHeight}px)`, flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff" }}>
                                                    {Array.isArray(data) && data.map((item, index) => {
                                                        return (
                                                            <div className="fields-box w-100">
                                                                <div className="fields flexcb br-6 p-2" style={{ transform: "none" }}>
                                                                    <div className="flexc">
                                                                        <label class="">
                                                                            <input type="checkbox" checked={(item?.showMain == undefined || !item?.showMain) ? false : true} onChange={() => this.changeShow(item, index)} />
                                                                        </label>
                                                                        <p className="font-size-13 main-c2 mx-2">{(item.name)}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div ref={el => this.button = el} className={" w-100 px-3 py-2 " + (conditionalWidth(this.props.width, { xs: 'flexcb', md: 'flexcb', xl: 'flexcb' }))} style={{ position: 'absolute', bottom: 0, borderTop: '1px solid #ededed', height: this.state.buttonHeight }}>
                                                    <div className="fields flexcb br-6 p-2" style={{ transform: "none" }}>
                                                        <div className="flexc">
                                                            <label class="">
                                                                <input type="checkbox" checked={this.state.checkedAll} onChange={() => this.changeShow('all')} />
                                                            </label>
                                                            <p className="font-size-14 main-c2 mx-2">{translate('Select all')}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <ButtonAnimated
                                                            iconwidth='24px'
                                                            onClick={() => { this.setShowData() }}
                                                            title={translate('Add to menu')}
                                                            icon='/assets/icons/plus-white.svg'
                                                            textColor={this.props.colors?.textColor ?? '#222'}
                                                            invert={this.props.colors?.iconInvert}
                                                            bg={background}
                                                        />
                                                    </div>
                                                </div>
                                                <button onClick={() => { this.setShowData() }}>
                                                    <p>{translate('Add to show')}</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Responsive> */}
                                {/* <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', sm: '12', md: '6', lg: '7', xl: '8' }}> */}
                                <div className="w-100 h-100  py-1 mb-4" style={{}}>

                                    <div ref={el => this.menu = el} className="w-100 py-2 flexcb" style={{ height: this.state.menuHeight }}>
                                        <p className="font-size-14 weight-500 main-c2">{translate('Menu')}</p>

                                        <button onClick={() => this.addNewFixedView.showView()} className="" ref={el => this.addNewBut = el}>
                                            <p className="text-link text-semibold">{translate('+ Add item')}</p>
                                        </button>
                                    </div>


                                    <div className="w-100 h-100 br-6" style={{ border: '1px solid #eee', position: 'relative' }}>

                                        <div className="w-100 px-3 py-2 " style={{}}>
                                            {Array.isArray(this.state.navigation?.list) && this.state.navigation?.list.length > 0 ? (
                                                <div className="flexc " style={{ flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff" }}>
                                                    <Board ref={el => this.board = el} setData={this.setData} columns={this.state.columns} list={this.state.navigation?.list} setPositionDiv={this.setPositionDiv} width={'100%'} updateList={this.updateList} openEdit={this.openEdit} />
                                                </div>
                                            ) : (
                                                <div className="w-100 h-100 flexcc flex-column py-2">
                                                    <img src="/assets/icons/useful/planet.png" width={70} />
                                                    <p className="font-size-14 main-c2 text-semibold mt-2">{translate('No Item is added to the menu yet')}</p>

                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                                {/* </Responsive> */}


                                {this.state.revealFixed && (
                                    <FixedView width={this.props.width} zIndex={10} ref={el => this.addNewFixedView = el} nodeRef={this.addNewBut} xOffset={-9} bottomOffset={27} topOffset={5} maxWidth={300} >
                                        <div className='bg-white br-10 p-2 shadow-3  ' style={{ width: 150 }}>
                                            <div className='p-1 sc-gray2 w-100' style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                                {MenuBuilderItems.map((item, index) => {
                                                    return (
                                                        <button className="py-1 flexc w-100" onClick={() => this.openAddItem(item)}>
                                                            <img src={item.icon} height={16} />
                                                            <p className="text-small text-semibold mld-3">{checkTranslation(item.label)}</p>
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </FixedView>
                                )}


                            </>
                        )}

                    </div>
                </div>


                <SidebarView width={this.props.width} ref={el => this.sidebarView = el} sideOpen={false} hideOverlay={false} widthCondition={{ xs: "90%", sm: "90%", md: '40%', lg: "30%", xl: "30%" }}>
                    <div className='sc-gray2 w-100 h-100'>

                        <div className="flexcb p-2" style={{ position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid #eee', backgroundColor: '#fff' }}>
                            <p className="text-bold font-size-16 py-1 px-2">{translate('Add menu item')}</p>
                            <div className="" >
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { this.applyConfig() }}
                                    title={translate('Apply')}
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={this.props.colors?.textColor ?? '#fff'}
                                    isLoading={this.state.isLoadingApply}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                                    width={'100%'}
                                />

                            </div>
                        </div>



                        <div className="pt-4">
                            <FormViewer ref={el => this.configForm = el} initData={this.state.currentItem?.information} headers={this.state.menuHeaders} formClass="bordered-form" inputClass={'bordered-input'} />
                        </div>

                    </div>
                </SidebarView>
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(NavigationsView);